import IconPlay from "@svg/product/Play";
import { useAccess } from "@templates/course/hooks/useAccess";
import { FC, useMemo } from "react";
import ImageComponent from "@shared/components/image";
import { resolveFeaturedThenThumbnailSources } from "utils/product-image";
import useProductVideoModal from "../../hook/useVideoModal";
import useGuestWatchtime from "@templates/course/hooks/useGuestWatchtime";
import { useLayoutContext } from "@context/layout";
import Player from "@modules/player";

const ProductCoverImage: FC = () => {
  const { courseData } = useAccess();
  const { fetstivalBanner } = useLayoutContext();
  const {
    product: { cover_video, title },
    lessons,
  } = courseData;
  const { showModalPreview } = useProductVideoModal(true);
  const updateWatchTime = useGuestWatchtime(
    courseData?.product?.id,
    lessons?.[0]?.id
  );

  const imageSources = useMemo(
    () => resolveFeaturedThenThumbnailSources(courseData.product),
    [courseData.product]
  );
  const showingImage = imageSources.src;

  const sources = useMemo(() => {
    return [
      { label: "720p", url: cover_video[720] },
      { label: "480p", url: cover_video[480] },
    ];
  }, [cover_video]);

  const hasVideo = Boolean(cover_video?.[720] || cover_video?.[480]);

  const isLcpCandidate = !fetstivalBanner?.is_active;

  return (
    <div className="relative w-full aspect-video rounded-8 overflow-hidden flex items-center justify-center">
      <ImageComponent
        fill
        src={showingImage}
        fallbackSrcs={imageSources.fallbackSrcs}
        priority={isLcpCandidate}
        fetchPriority="high"
        sizes="(min-width: 1024px) 384px, 100vw"
        className={
          showingImage ? (hasVideo ? "hidden lg:block" : "") : "hidden"
        }
        alt={title || ""}
      />
      {hasVideo && (
        <>
          <div className="lg:hidden w-full h-full">
            <Player
              sources={sources}
              poster={showingImage || ""}
              showTheater={false}
              autoPlayOnSrcChange={false}
              theaterMode={false}
              id={`abstract-${courseData.product.id}`}
              className={
                hasVideo ? "pt-0 aspect-video w-full block lg:hidden" : "hidden"
              }
              isPreview
              timeUpdateHandler={updateWatchTime}
            />
          </div>
          <div
            className="absolute w-full h-full justify-center items-center z-10 cursor-pointer hidden lg:flex"
            onClick={() => {
              showModalPreview(lessons?.[0]);
            }}
          >
            <div className="bg-[rgba(64,67,71,.6)] text-fds-icon-always-white absolute flex justify-center items-center h-16 w-16 rounded-full">
              <IconPlay className="w-6  h-6" />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ProductCoverImage;
